export const Email = {
    support: 'support@kiwihealth.com',
    provider_support: 'provider_support@mail.boxpractice.com',
    onboarding: 'onboarding@helloklarity.com',
    klarity_provider_support: 'providersupport@helloklarity.com',
};
